import React from 'react';
import { Platform, StyleSheet, TouchableOpacity } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { isTablet } from 'react-native-device-info';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import 'react-native-reanimated';
import { menuRef } from '../navigation/MenuNavigation';
import colors from '../resources/colors';

const MenuComponent = ({
  menuOffset,
  menuBackgroundOffset,
  menuOpen,
  menuButtonPressed,
  children,
}) => {
  const menuStyle = useAnimatedStyle(() => ({
    transform: [{ translateX: menuOffset.value }],
  }));

  const menuBackgroundStyle = useAnimatedStyle(() => ({
    opacity: menuBackgroundOffset.value,
  }));

  const showMenuBackground = menuOpen;

  // console.log('showMenuBackground', showMenuBackground);

  const disabledView = showMenuBackground && (
    <Animated.View style={[styles.menuBackgroundContainer, menuBackgroundStyle]}>
      <TouchableOpacity
        activeOpacity={1}
        style={styles.menuBackgroundButton}
        onPress={() => menuButtonPressed(false)}
      />
    </Animated.View>
  );

  return (
    <>
      {disabledView}
      <Animated.View style={[styles.menu, menuStyle]}>
        <NavigationContainer ref={menuRef} independent={true}>
          {children}
        </NavigationContainer>
      </Animated.View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
  menuBackgroundContainer: {
    flex: 1,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  menuBackgroundButton: {
    flex: 1,
    backgroundColor: 'rgba(39,41,44,0.6)',
  },
  menu: {
    flex: 1,
    overflow: 'hidden',
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: isTablet() || Platform.OS === 'web' ? 375 : '80%',
    shadowColor: 'rgba(0, 0, 0, 0.1)',
    shadowOffset: {
      width: 3,
      height: 0,
    },
    shadowRadius: 0,
    shadowOpacity: 1,
    elevation: 3,
    zIndex: 2,
    backgroundColor: colors.accentBlack,
  },
});

export default MenuComponent;
